import { useState, useEffect } from 'react';
import { useNavigate, useLocation } from 'react-router-dom';
import { Button } from '../components/ui/button';
import { Card, CardContent, CardHeader, CardTitle } from '../components/ui/card';
import { ScrollArea } from '../components/ui/scroll-area';
import { FileText, ArrowLeft } from 'lucide-react';
import axios from 'axios';

const API = `${process.env.REACT_APP_BACKEND_URL}/api`;

const Terms = () => {
  const [terms, setTerms] = useState(null);
  const [loading, setLoading] = useState(true);
  const navigate = useNavigate();
  const location = useLocation();
  
  // Check if we came from membership/register page
  const fromMembership = location.state?.fromMembership;
  const returnTo = location.state?.returnTo || '/membership';

  useEffect(() => {
    fetchTerms();
  }, []);

  const fetchTerms = async () => {
    try {
      const response = await axios.get(`${API}/terms`);
      setTerms(response.data);
    } catch (error) {
      console.error('Error fetching terms:', error);
    } finally {
      setLoading(false);
    }
  };

  if (loading) {
    return (
      <div className="min-h-screen flex items-center justify-center">
        <div className="spinner" />
      </div>
    );
  }

  return (
    <div className="min-h-screen bg-secondary/30 py-12">
      <div className="container-custom max-w-4xl mx-auto px-4">
        <Button 
          variant="ghost" 
          onClick={() => navigate(returnTo)}
          className="mb-6"
          data-testid="back-btn"
        >
          <ArrowLeft className="w-4 h-4 mr-2" />
          Back
        </Button>

        <Card>
          <CardHeader className="border-b border-border">
            <CardTitle className="flex items-center gap-3">
              <FileText className="w-6 h-6 text-gold" />
              {terms?.title || 'Terms & Conditions'}
            </CardTitle>
            {terms?.last_updated && (
              <p className="text-sm text-muted-foreground">
                Last updated: {terms.last_updated}
              </p>
            )}
          </CardHeader>
          <CardContent className="p-0">
            <ScrollArea className="h-[60vh]">
              <div className="p-6 space-y-8">
                {terms?.sections?.map((section, index) => (
                  <div key={index} className="space-y-3">
                    <h2 className="text-lg font-semibold">{section.title}</h2>
                    <p className="text-muted-foreground leading-relaxed">
                      {section.content}
                    </p>
                  </div>
                ))}
              </div>
            </ScrollArea>
          </CardContent>
        </Card>

        {fromMembership && (
          <div className="mt-6 flex justify-center">
            <Button 
              onClick={() => navigate(returnTo)}
              className="bg-gold text-primary hover:bg-gold/90"
              data-testid="accept-terms-btn"
            >
              I Understand, Continue to Membership
            </Button>
          </div>
        )}
      </div>
    </div>
  );
};

export default Terms;
